import type { CheckoutPlanId } from '../data/pricingPlans'
/**
 * The plan a visitor picked before authenticating. Persisted so the
 * checkout they started survives the login / signup detour.
 */
const SELECTED_PLAN_KEY = 'toxicdetector.selected_plan'
const VALID_PLANS: CheckoutPlanId[] = [
  'single_scan',
  'weekly',
  'monthly',
  'yearly',
]
function isCheckoutPlanId(value: string | null): value is CheckoutPlanId {
  return !!value && VALID_PLANS.includes(value as CheckoutPlanId)
}
export function storeSelectedPlan(plan: CheckoutPlanId): void {
  try {
    window.localStorage.setItem(SELECTED_PLAN_KEY, plan)
  } catch {
    // Storage unavailable (private mode) — checkout still works, it just
    // will not resume automatically after authentication.
  }
}
export function getSelectedPlan(): CheckoutPlanId | null {
  try {
    const stored = window.localStorage.getItem(SELECTED_PLAN_KEY)
    return isCheckoutPlanId(stored) ? stored : null
  } catch {
    return null
  }
}
export function clearSelectedPlan(): void {
  try {
    window.localStorage.removeItem(SELECTED_PLAN_KEY)
  } catch {
    // no-op
  }
}
/** Accepts a `?plan=` query value, keeping only known plan identifiers. */
export function normalizePlanParam(value: string | null): CheckoutPlanId | null {
  return isCheckoutPlanId(value) ? value : null
}
